const FROM_SIDEBAR_KEY = 'from-sidebar';
const FROM_SIDEBAR_GRACE_MS = 500;

/**
 * Dims sidebar elements when user scrolls down
 * Elements with [data-scroll-dim] will get dimmer after scrolling past threshold
 */
class ScrollDim {
  constructor() {
    this.container = document.querySelector('.entry-layout');
    if (!this.container) return;
    
    this.scrollThreshold = 50; // Start dimming after 50px scroll
    this.isScrolled = false;
    
    this.init();
  }
  
  init() {
    // Track Index sidebar link clicks so we can show full opacity after navigation
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.addEventListener('click', (e) => {
        const link = e.target.closest('a[href]');
        if (link && link.hostname === window.location.hostname) {
          sessionStorage.setItem(FROM_SIDEBAR_KEY, '1');
        }
      }, true);
    }
    
    // If we navigated from a sidebar link, force full opacity briefly to avoid
    // jank (Safari won't apply :hover to fresh DOM; others may flash dim→bright)
    if (sessionStorage.getItem(FROM_SIDEBAR_KEY)) {
      this.container.classList.add('from-sidebar-nav');
      sessionStorage.removeItem(FROM_SIDEBAR_KEY);
      setTimeout(() => {
        this.container.classList.remove('from-sidebar-nav');
      }, FROM_SIDEBAR_GRACE_MS);
    }
    
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    this.handleScroll(); // Check initial state
  }
  
  handleScroll() {
    const distanceFromTop = window.scrollY;
    const distanceFromBottom = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
    
    // Show dimmed state only when past top threshold AND not near bottom
    const scrolled = distanceFromTop > this.scrollThreshold && distanceFromBottom > this.scrollThreshold;
    
    if (scrolled !== this.isScrolled) {
      this.isScrolled = scrolled;
      this.container.classList.toggle('is-scrolled', scrolled);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ScrollDim());
} else {
  new ScrollDim();
}
